import { useState } from 'react';
import useAxiosWithAuth from './useAxiosWithAuth';

const useGraphqlService = () => {
    const axiosWithAuth = useAxiosWithAuth();
    const [loading, setLoading] = useState(false);

    const sendGraphqlRequest = async (query, variables = {}) => {
        setLoading(true);
        try {
            const response = await axiosWithAuth.post('/graphql', {
                query,
                variables,
            });
            setLoading(false);
            if (response.data.errors) {
                throw new Error('GraphQL Error: ' + response.data.errors.map(e => e.message).join(', '));
            }
            return response.data.data;
        } catch (error) {
            setLoading(false);
            console.error('GraphQL Error:', error);
            throw error;
        }
    };

    return { sendGraphqlRequest, loading };
};

export default useGraphqlService;
